import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Bot } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { AgentWizard } from '@/components/agents/wizard/agent-wizard'

export function AgentEditPage() {
  const { t } = useTranslation('agents')
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const showPlayground = searchParams.get('playground') === 'true'

  if (!id) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <div className="w-20 h-20 rounded-2xl bg-red-500/20 flex items-center justify-center mb-6">
          <Bot className="w-10 h-10 text-red-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-200 mb-2">
          {t('edit.notFound')}
        </h3>
        <p className="text-gray-500 text-center max-w-md mb-6">
          {t('edit.notFoundDesc')}
        </p>
        <Button
          variant="outline"
          className="gap-2"
          onClick={() => navigate('/agents')}
        >
          <ArrowLeft className="w-4 h-4" />
          {t('edit.backToAgents')}
        </Button>
      </div>
    )
  }

  const handleSuccess = () => {
    navigate('/agents')
  }

  const handleCancel = () => {
    navigate('/agents')
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/agents')}
          className="text-gray-400 hover:text-white"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-white">{t('edit.title')}</h1>
          <p className="text-sm text-gray-400">
            {t('edit.subtitle')}
          </p>
        </div>
      </div>

      {/* Wizard in Edit Mode */}
      <AgentWizard
        editMode
        agentId={id}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        initialShowPlayground={showPlayground}
      />
    </div>
  )
}
